import React, { useContext, useEffect, useState } from "react";
import DEF from "../../assets/images/DEF.svg";
import { FilterContext } from "../../context/Filter";
import { getvascount, getvascountfmc } from "./VasUnderFleetKpi";
import vas_icon1 from "../../assets/images/vasicon1.jpg";
import vas_icon2 from "../../assets/images/vas_icon2.jpg";
import { Link } from "react-router-dom";
import spareSalesImg from "../../assets/images/spareSalesDetails.svg";

const Vastable = () => {
  const { arn: parArn, childArn } = useContext(FilterContext);
  const [selectedValue, setSelectedValue] = useState("");
  const [fmsval, setFmsval] = useState("");
  const [vasval, setVasval] = useState("");

  const value = childArn ?? parArn ?? ""; // prioritizes childArn
  const key = childArn ? "childArn" : "parArn"; // determines the key dynamically
  const payload = { [key]: value };

  useEffect(() => {
    const fetchData = async () => {
      let payload;

      if (childArn) {
        payload = { childArn };
      } else if (parArn) {
        payload = { parArn };
      } else {
        // Nothing to send, skip API call
        return;
      }

      const fmsResult = await getvascountfmc(payload);
      setFmsval(fmsResult?.value);

      const vasResult = await getvascount(payload);
      setVasval(vasResult?.value);
    };

    fetchData();
  }, [parArn, childArn]);



  return (
    <div>
      {/* Header with Filter */}
      <div className="bg-[#2374BF] text-white    rounded-t-lg flex text-center justify-between items-center">
        <h2 className="text-md p-1 pl-2 font-semibold ">VAS</h2>
        <Link
          to={"/vas-underFleet"}
          className="flex gap-2 items-center justify-end w-full"
        >
          <p className="text-sm text-white">VAS details</p>
          <img src={spareSalesImg} alt="spare sales details" />
        </Link>

        <div className="relative">
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-white"></div>
        </div>
      </div>

      <div className="flex flex-row py-4 justify-center px-2 gap-4">
        {/* Card 1 */}
        <div className=" flex flex-col  p-4  rounded-lg shadow-xl border w-64 h-32 items-center justify-center justify-items-center">
          <div className="mb-1 flex   flex-col">
            <img src={vas_icon1} alt="DEF Icon" className="h-9 w-24" />

            <div className="text-[#5f9ade] font-bold text-3xl text-center">
              {vasval}
            </div>
            <div className="text-sm text-center">AMC</div>
          </div>
        </div>

        <div className="flex flex-col border p-4 rounded-lg shadow-xl w-64 h-32 items-center justify-center">
          <div className="mb-2 flex flex-col">
            <img src={vas_icon2} alt="DEF Icon" className="h-9 w-24" />

            <div className="text-[#5f9ade] font-bold text-3xl text-center">
              {fmsval}
            </div>
            <div className="text-sm text-center">FMS</div>
          </div>
        </div>
      </div>
      {/* Bottom Note */}
      <div className="px-2 text-sm text-gray-500 text-center "></div>
    </div>
  );
};

export default Vastable;
